import { render, staticRenderFns } from "./editswitchmodel.vue?vue&type=template&id=316fb59b&"
import script from "./editswitchmodel.vue?vue&type=script&lang=ts&"
export * from "./editswitchmodel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editswitchmodel.vue"
export default component.exports